
export default {
  methods: {
    sanitizeForExample(sumario, formType) {
      const S = JSON.parse(JSON.stringify(sumario || {}));

      // Campos que sobran para el example
      const DROP_ROOT = new Set([
        "saveStatus",
        "isSaving",
        "timer",
        "originalUser",
        "spinnerOrderTablePrintFrom",
        "actuationEditModeActive",
      ]);
      Object.keys(S).forEach((k) => {
        if (DROP_ROOT.has(k)) delete S[k];
      });

      // causaNumero sin barra
      if (S.causaNumero && typeof S.causaNumero === "string") {
        S.causaNumero = S.causaNumero.split("/")[0];
      }

      // Normalización de fechas
      const toDate = (v) => {
        if (!v) return new Date();
        if (v instanceof Date) return v;
        const d = new Date(v);
        return isNaN(d.getTime()) ? new Date() : d;
      };

      if (S.moment) {
        S.moment = {
          date: toDate(S.moment.date),
          date2: toDate(S.moment.date2),
        };
      }

      S.preMoment = {
        date: toDate(S.preMoment?.date),
        date2: toDate(S.preMoment?.date2),
      };

      if (S.fechaDenuncia) S.fechaDenuncia = toDate(S.fechaDenuncia);

      // Personal Fiscal
      if (S.prosecutor || S.assistant) {
        S.PersonalFiscal = [];
        if (S.prosecutor) S.PersonalFiscal.push(S.prosecutor);
        if (S.assistant) S.PersonalFiscal.push(S.assistant);
      }

      // Limpieza recursiva
      const prune = (obj) => {
        if (Array.isArray(obj)) {
          return obj
            .map(prune)
            .filter(
              (x) =>
                !(
                  x == null ||
                  (typeof x === "object" &&
                    !Array.isArray(x) &&
                    Object.keys(x).length === 0)
                )
            );
        }
        if (obj && typeof obj === "object") {
          Object.keys(obj).forEach((k) => {
            const v = prune(obj[k]);
            const empty =
              v == null ||
              v === "" ||
              (typeof v === "object" &&
                ((Array.isArray(v) && v.length === 0) ||
                  (!Array.isArray(v) && Object.keys(v).length === 0)));
            if (empty) delete obj[k];
            else obj[k] = v;
          });
          return obj;
        }
        return obj;
      };

      const cleaned = prune(S) || {};
      cleaned.formType = formType || S.formType || this.formType;
      return cleaned;
    },

    toJS(value, indent = 2, level = 2) {
      const pad = (lvl) => " ".repeat(lvl);

      if (value instanceof Date) {
        return `new Date("${value.toString()}")`;
      }
      if (Array.isArray(value)) {
        if (!value.length) return "[]";
        return `[\n${value
          .map((v) => pad(level) + this.toJS(v, indent, level + indent))
          .join(",\n")}\n${pad(level - indent)}]`;
      }
      if (value && typeof value === "object") {
        const keys = Object.keys(value);
        if (!keys.length) return "{}";
        return `{\n${keys
          .map((k) => pad(level) + `${k}: ${this.toJS(value[k], indent, level + indent)}`)
          .join(",\n")}\n${pad(level - indent)}}`;
      }
      return JSON.stringify(value);
    },
    // Genera un snippet tipo example.js listo para copiar
    buildExampleSnippet(formType, exampleObj) {
      if (!exampleObj.preMoment) {
        exampleObj.preMoment = { date: new Date(), date2: new Date() };
      }

      let json = JSON.stringify(exampleObj, null, 2);

      json = json.replace(/"date"\s*:\s*"([^"]+)"/g, '"date": new Date("$1")');
      json = json.replace(/"date2"\s*:\s*"([^"]+)"/g, '"date2": new Date("$1")');

      json = json.replace(
        /"preMoment": \{\s*"date":\s*"([^"]+)",\s*"date2":\s*"([^"]+)"\s*\}/g,
        (_m, d1, d2) =>
          `"preMoment": { date: new Date("${d1}"), date2: new Date("${d2}") }`
      );

      json = json.replace(
        /"fechaDenuncia"\s*:\s*"([^"]*)"/,
        (_m, iso) =>
          `"fechaDenuncia": ${
            iso ? `new Date("${iso}")` : "new Date()"
          }`
      );

      return `"${formType}": ${json},`;
    },

    // Copia texto al portapapeles
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
      } catch {
        const ta = document.createElement("textarea");
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
    },
  },
};
